import { render, staticRenderFns } from "./PDFViewerToolbarZoomControl.vue?vue&type=template&id=48b97e89&scoped=true&lang=pug"
import script from "./PDFViewerToolbarZoomControl.vue?vue&type=script&lang=ts"
export * from "./PDFViewerToolbarZoomControl.vue?vue&type=script&lang=ts"
import style0 from "./PDFViewerToolbarZoomControl.vue?vue&type=style&index=0&id=48b97e89&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b97e89",
  null
  
)

export default component.exports